import { render, staticRenderFns } from "./SellWant.vue?vue&type=template&id=18541cd2&scoped=true"
import script from "./SellWant.vue?vue&type=script&lang=js"
export * from "./SellWant.vue?vue&type=script&lang=js"
import style0 from "./SellWant.vue?vue&type=style&index=0&id=18541cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18541cd2",
  null
  
)

export default component.exports